import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store'
import axios from 'axios'
import VueAnalytics from 'vue-analytics'
import CommonLayout from '../components/common/Layout'
import CustomerLayout from '../components/customer/Layout'
import ShopLayout from '../components/shop/Layout'
import ConsoleLayout from '../components/console/Layout'

function lazyLoad (view) {
  return () => import(`@/pages/${view}`)
}

Vue.use(Router)

store.commit('account/LOAD')
store.dispatch('cart/LOAD')

const router = new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    // 前端客戶使用畫面(no Layout)
    {
      path: '/',
      redirect: '/homepage',
      component: CommonLayout,
      children: [
        {
          path: 'password_reset',
          name: 'PasswordResetSend',
          component: lazyLoad('PasswordResetSend')
        },
        {
          path: 'password_reset/:token?',
          name: 'PasswordReset',
          meta: { tokencheck: true, redirect: 'password_reset', type: 'ResetPassword' },
          component: lazyLoad('PasswordReset')
        },
        {
          path: 'email_verify/:token?',
          name: 'EmailVerify',
          meta: { tokencheck: true, redirect: 'email_verify', type: 'VerifyEmail' },
          component: lazyLoad('EmailVerify')
        }
      ]
    },
    // 前端客戶使用畫面(Layout)
    {
      path: '/',
      redirect: '/homepage',
      component: CustomerLayout,
      children: [
        {
          path: 'error',
          component: lazyLoad('Error')
        },
        {
          path: 'notFound',
          component: lazyLoad('NotFound')
        },
        {
          path: 'homepage',
          name: 'Homepage',
          component: lazyLoad('Homepage')
        },
        {
          path: 'homepage/:category',
          name: 'HomepageCategory',
          component: lazyLoad('HomepageCategory')
        },
        {
          path: 'about',
          name: 'About',
          component: lazyLoad('About')
        },
        {
          path: 'aboutus',
          name: 'Aboutus',
          component: lazyLoad('Aboutus')
        },
        {
          path: 'restaurant/:shopid',
          name: 'Restaurant',
          component: lazyLoad('Restaurant')
        },
        {
          path: 'privacy/policy',
          name: 'PrivacyRule',
          component: lazyLoad('PrivacyRule')
        },
        {
          path: 'services/terms',
          name: 'ServiceRule',
          component: lazyLoad('ServiceRule')
        },
        {
          path: 'product',
          name: 'ProductSolution',
          component: lazyLoad('ProductSolution')
        }
      ]
    },

    // 前端權限
    {
      path: '/customer',
      redirect: '/customer/orders',
      component: CustomerLayout,
      meta: { requireAuth: true },
      children: [
        {
          path: 'orders',
          name: 'CustomerOrders',
          component: lazyLoad('customer/CustomerOrders')
        },
        {
          path: 'account',
          name: 'CustomerAccount',
          component: lazyLoad('customer/CustomerAccount')
        },
        {
          path: 'yumcoin',
          name: 'CustomerCoin',
          component: lazyLoad('customer/CustomerCoin')
        },
        {
          path: 'help',
          name: 'CustomerHelp',
          component: lazyLoad('customer/CustomerHelp')
        }
      ]
    },

    // 後端店家使用畫面
    {
      path: '/shop',
      redirect: '/shop/list',
      component: ShopLayout,
      meta: { requireAuth: true },
      children: [
        {
          path: 'list',
          name: 'ShopList',
          component: lazyLoad('shop/ShopList')
        },
        {
          path: ':shopid/discount',
          name: 'ShopDiscount',
          component: lazyLoad('shop/ShopDiscount')
        },
        {
          path: ':shopid/orders',
          name: 'ShopOrders',
          component: lazyLoad('shop/ShopOrders')
        },
        {
          path: ':shopid/reservations',
          name: 'ShopReservations',
          component: lazyLoad('shop/ShopReservations')
        },
        {
          path: ':shopid/meal',
          name: 'ShopMeal',
          component: lazyLoad('shop/shopMeal/ShopMeal')
        },
        {
          path: ':shopid/history',
          name: 'ShopHistory',
          component: lazyLoad('shop/ShopHistory')
        },
        {
          path: ':shopid/info',
          name: 'ShopInfo',
          component: lazyLoad('shop/ShopInfo')
        },
        {
          path: ':shopid/edit',
          name: 'ShopEdit',
          component: lazyLoad('shop/ShopEdit')
        },
        {
          path: ':shopid/shopMenu',
          component: lazyLoad('shop/shopMenu/ShopMenu'),
          children: [
            { path: 'status', name: 'ShopMenuStatus', component: lazyLoad('shop/shopMenu/ShopMenuStatus') },
            { path: 'category', name: 'ShopMenuCategory', component: lazyLoad('shop/shopMenu/ShopMenuCategory') },
            { path: 'cust', name: 'ShopMenuCustomization', component: lazyLoad('shop/shopMenu/ShopMenuCustomization') },
            { path: '', redirect: 'status' }
          ]
        },
        {
          path: ':shopid/analysis',
          name: 'ShopAnalysis',
          component: lazyLoad('shop/ShopAnalysis')
        },
        {
          path: ':shopid/help',
          name: 'ShopHelp',
          component: lazyLoad('shop/Help')
        },
        {
          path: ':shopid/comment',
          name: 'ShopComment',
          component: lazyLoad('shop/shopComment')
        },
        {
          path: ':shopid/permission',
          name: 'ShopPermission',
          component: lazyLoad('shop/ShopPermission')
        },
        {
          path: ':shopid/authority',
          name: 'ShopAuthority',
          component: lazyLoad('shop/ShopAuthority')
        },
        {
          path: ':shopid/stock',
          name: 'ShopStock',
          component: lazyLoad('shop/ShopStock')
        },
        {
          path: ':shopid/resource',
          name: 'ShopResource',
          component: lazyLoad('shop/shopResource')
        },
        {
          path: ':shopid/yumcoin',
          name: 'ShopCoin',
          component: lazyLoad('shop/ShopCoin')
        },
        {
          path: 'backend',
          name: 'ShopAdmin',
          component: lazyLoad('shop/ShopAdmin')
        },
        {
          path: ':shopid/bill',
          component: lazyLoad('shop/shopBill/ShopBill'),
          children: [
            { path: 'detail', name: 'ShopDetail', component: lazyLoad('shop/shopBill/ShopDetail') },
            { path: 'payment', name: 'ShopPayment', component: lazyLoad('shop/shopBill/ShopPayment') },
            { path: 'collection', name: 'ShopCollection', component: lazyLoad('shop/shopBill/ShopCollection') },
            { path: '', redirect: 'detail' }
          ]
        },
        {
          path: '*',
          redirect: '/shop/list'
        }
      ]
    },

    {
      path: '/console',
      redirect: '/console/news',
      component: ConsoleLayout,
      meta: { requireAuth: true, requireRole: 'Admin' },
      children: [
        {
          path: 'news',
          name: 'ConsoleNews',
          component: lazyLoad('console/News')
        },
        {
          path: 'shops',
          name: 'ConsoleShops',
          component: lazyLoad('console/ShopList')
        },
        {
          path: 'coin',
          name: 'ConsoleCoin',
          component: lazyLoad('console/Coin')
        },
        {
          path: 'recommendCode',
          name: 'RecommendCode',
          component: lazyLoad('console/RecommendCode')
        }
      ]
    },

    {
      path: '/brand',
      name: 'brand',
      component: lazyLoad('brand/Brand')
    },

    // Test
    // {
    //   path: '/test/sticky',
    //   name: 'StickyHeader',
    //   component: lazyLoad('Test/StickyHeader')
    // },
    // {
    //   path: '/test/map',
    //   name: 'GoogleMap',
    //   component: lazyLoad('Test/Map')
    // },
    // {
    //   path: '/test/firestore',
    //   name: 'FireStore',
    //   component: lazyLoad('Test/Firestore')
    // },

    // 例外
    {
      path: '*',
      redirect: '/'
    }
  ]
})
let methods = {
  async checkAuth () {
    store.commit('account/LOAD')
    return Promise.resolve(store.getters['account/IS_LOGIN'])
  },
  async checkRole (role) {
    return Promise.resolve(store.getters['account/WITH_ROLE'](role))
  },
  async checkToken (type, token) {
    try {
      let response = await axios.put(`/api/Account/Token/Verify?token=${token}&type=${type}`)
      console.log('response : ' + response)
      return response.status === 200
    } catch (error) {
      return false
    }
  }
}
router.beforeEach(async (to, from, next) => {
  // 檢查權限
  if (to.matched.some((r) => r.meta.requireAuth)) {
    let matched = to.matched.find((r) => r.meta.requireAuth)
    let unauth = false
    if (!await methods.checkAuth()) {
      unauth = true
    } else if (matched.meta.requireRole && !await methods.checkRole(matched.meta.requireRole)) {
      unauth = true
    }
    if (unauth) {
      next({
        path: '/', params: { fail: true }
      })
    }
  }
  // 檢查token
  if (to.matched.some((r) => r.meta.tokencheck)) {
    let _invalid = to.params.token && !await methods.checkToken(to.meta.type, to.params.token)
    if (_invalid) {
      store.commit('msg/SET_TOKEN_MSG', true)
      if (to.meta.redirect) {
        console.log('redirect : ' + to.meta.redirect)
        next({
          path: to.meta.redirect
        })
      } else {
        next({
          path: '/'
        })
      }
    }
  }
  next()
})

export default router
Vue.use(VueAnalytics, {
  id: 'UA-158800883-1',
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js